$('select[name="cboDegreeProgYear"]').change(function () {
    window.location = base_url + 'importantdocuments/report/download?degreeprogyr=' + $(this).val() + '&docid=' + $('select[name="cboImportantdocs"]').val();
});

$('select[name="cboImportantdocs"]').change(function () {
    window.location = base_url + 'importantdocuments/report/download?degreeprogyr=' + $('select[name="cboDegreeProgYear"]').val() + '&docid=' + $(this).val();
});

$('#select_all').change(function (event) { // Select all checkboxes
    $(':checkbox').prop('checked', $(this).prop('checked'));
});
